// extracted by mini-css-extract-plugin
module.exports = {"brandsFooter":"BrandsFooter_brandsFooter__jAZ0r","section":"BrandsFooter_section__ss_9A"};